import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ApBaseClass, INavigationScrollingService } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class NavigationScrollingService extends ApBaseClass implements INavigationScrollingService {
  private document?: Document;

  // strictMetadataEmit in config causes this to have to be casted from any to not throw compile error.
  // https://github.com/angular/angular/issues/20351
  constructor(@Inject(DOCUMENT) doc?: any) {
    super();
    this.document = doc as Document;
  }

  scrollToId(elementId: string, options?: ScrollIntoViewOptions) {
    if (!this.document) { return; }

    const scrollToEle = this.document.getElementById(elementId);
    if (!scrollToEle) { return; }

    scrollToEle.scrollIntoView(options);
  }
}
